import { ViewModel,View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { AtomicDetail, AtomicValue } from "../distinguishingDetailDefinition-viewModel";
import  { DistinguishingDetailValueUpdaterView } from "./distinguishingDetailValueUpdater-view"

export class DistinguishingDetailValueUpdaterViewModel extends ViewModel implements IPopup {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.values = ObservableArray.create<singleValue>();
    }
    
    GetDefaultView(): View <ViewModel> {
        return new DistinguishingDetailValueUpdaterView();
    }
    public getTypeId(): string {
        return "VM-48199AA3-ADE8-4CEC-8424-DA453BA4C7F4"
    }

    private parentDetail:AtomicDetail;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set values(v: ObservableArray<singleValue>) { this._values = v; } public get values(): ObservableArray<singleValue> { return this._values;} private _values: ObservableArray<singleValue>;
    private newOnes:ObservableArray<singleValue>=ObservableArray.create<singleValue>();
    private updatedOnes:ObservableArray<singleValue>=ObservableArray.create<singleValue>();
    private deletedOnes:ObservableArray<singleValue>=ObservableArray.create<singleValue>();
    
    loadForDetail(detail:AtomicDetail) {
        this.parentDetail = detail;
        this.loadData();
    }

    async loadData(){
        try {
            this.isLoading = true;
            let values = await this.parentDetail.getValues();
            this.values.update(...values.map(x=>{
                let r = new singleValue(this);
                r.code = x.code;
                r.id = x.id;
                r.isNew = false;
                r.isUpdated = false;
                r.name = x.name;
                r.relatedValue = x;
                return r;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    confirm(){
        this.parentDetail.updateValues(this.newOnes,this.updatedOnes,this.deletedOnes);
        this.closePopup("done");
    }
    cancel(){
        this.closePopup("cancel");
    }
    closePopup(resultCode: string) {
    }
    
    remove(singleValue:singleValue){
        this.values.remove(singleValue);
        if(singleValue.isNew){
            this.newOnes.remove(singleValue)
        }else if(this.updatedOnes.indexOf(singleValue)>-1){
            this.updatedOnes.remove(singleValue);
        }else{
            this.deletedOnes.push(singleValue);
        }
    }

    updated(singleValue:singleValue){
        if(singleValue.isNew==false && this.updatedOnes.indexOf(singleValue)==-1){
            this.updatedOnes.push(singleValue);
        }
    }
    addNew(){
        let newOne = new singleValue(this);
        newOne.isNew = true;
        this.newOnes.push(newOne);
        this.values.push(newOne);
    }
}

export class singleValue extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:DistinguishingDetailValueUpdaterViewModel) {
        super(parent);
        this._updaterViewModel = parent;
        this.isNew = false;
        this.isUpdated = false;
    }
    private _updaterViewModel:DistinguishingDetailValueUpdaterViewModel;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; this.updated(); } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; this.updated(); } public get code(): string { return this._code;} private _code: string;
    public isNew:boolean;
    public isUpdated:boolean;
    public relatedValue:AtomicValue;

    updated(){
        if(this.isUpdated==false && this.isNew==false){
            this.isUpdated = true;
            this._updaterViewModel.updated(this);
        }
    }

    remove(){
        this._updaterViewModel.remove(this);
    }
}
